import { createSelector } from 'reselect';
import { TApplicationState } from '../libs/store';

const rosterHistoryState = (state: TApplicationState) => state.rosterHistory;

export const isLoadingRosterHistorySelector = createSelector(
  rosterHistoryState,
  (rosterHistory) => rosterHistory.isLoading
);

export const rosterHistorySelector = createSelector(rosterHistoryState, (rosterHistory) => rosterHistory.history);

export const isLoadedRosterHistorySelector = createSelector(
  rosterHistoryState,
  (rosterHistory) => rosterHistory.isLoaded
);

export const rosterScopeDaysSelector = createSelector(rosterHistoryState, (rosterHistory) => rosterHistory.scopeDays);
